export default {
  name: 'vx-campaign-giants-slides',
  data() {
    return {

    };
  },
  props: {
    slide: {
      type: Array,
    },
    currentIndex: {
      type: Number,
    },
    currentSlider: {
      type: Object,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-giants/vx-campaign-giants-slides/vx-campaign-giants-slides.js